export var separateFileNameExtension = function separateFileNameExtension(_ref) {
  var fileName = _ref.fileName,
      _ref$padExtension = _ref.padExtension,
      padExtension = _ref$padExtension === void 0 ? 0 : _ref$padExtension;
  var file = fileName.split('/').pop();
  var dotIndex = file.lastIndexOf('.'); // if no file ext present

  if (dotIndex <= 0) {
    return {
      name: file,
      extension: null
    };
  }

  if (dotIndex - padExtension <= 0) {
    return {
      name: file.substr(0, file.lastIndexOf('.')),
      extension: file.substr(file.lastIndexOf('.'), file.length)
    };
  }

  return {
    name: file.substr(0, file.lastIndexOf('.') - padExtension),
    extension: file.substr(file.lastIndexOf('.') - padExtension, file.length)
  };
};